import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { treeClass } from './styles';
import Spin from '../Spin';
import Checkbox from './Checkbox';
import { CHANGE_TOPIC } from '../Datum/types';
var loading =
/*#__PURE__*/
React.createElement("span", {
  className: treeClass('icon-loading')
},
/*#__PURE__*/
React.createElement(Spin, {
  name: "ring",
  size: 12
}));

var Content =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Content, _PureComponent);

  var _super = _createSuper2(Content);

  function Content(props) {
    var _this;

    _classCallCheck(this, Content);

    _this = _super.call(this, props);
    _this.handleNodeClick = _this.handleNodeClick.bind(_assertThisInitialized(_this));
    _this.handleNodeExpand = _this.handleNodeExpand.bind(_assertThisInitialized(_this));
    _this.handleIndicatorClick = _this.handleIndicatorClick.bind(_assertThisInitialized(_this));
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Content, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(Content.prototype), "componentDidMount", this).call(this);

      var datum = this.props.datum;
      datum.subscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(Content.prototype), "componentWillUnmount", this).call(this);

      var datum = this.props.datum;
      datum.unsubscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "handleNodeClick",
    value: function handleNodeClick() {
      var _this$props = this.props,
          data = _this$props.data,
          id = _this$props.id,
          parentClickExpand = _this$props.parentClickExpand,
          childrenKey = _this$props.childrenKey;
      var children = data[childrenKey];
      var hasChildren = children && children.length > 0;

      if (hasChildren && parentClickExpand) {
        this.handleIndicatorClick();
      } else {
        this.props.onNodeClick(data, id);
      }
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      this.forceUpdate();
    }
  }, {
    key: "handleNodeExpand",
    value: function handleNodeExpand() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          childrenKey = _this$props2.childrenKey,
          doubleClickExpand = _this$props2.doubleClickExpand;
      if (!doubleClickExpand) return;
      var children = data[childrenKey];
      var hasChildren = children && children.length > 0;
      if (hasChildren) this.handleIndicatorClick();
    }
  }, {
    key: "handleIndicatorClick",
    value: function handleIndicatorClick() {
      var _this$props3 = this.props,
          id = _this$props3.id,
          data = _this$props3.data,
          onToggle = _this$props3.onToggle,
          loader = _this$props3.loader,
          childrenKey = _this$props3.childrenKey,
          setFetching = _this$props3.setFetching;
      onToggle();
      if (data[childrenKey] !== undefined) return;
      setFetching(true);
      if (loader) loader(id, data);
    }
  }, {
    key: "renderNode",
    value: function renderNode() {
      var _this$props4 = this.props,
          id = _this$props4.id,
          active = _this$props4.active,
          data = _this$props4.data,
          renderItem = _this$props4.renderItem,
          expanded = _this$props4.expanded;
      var render = typeof renderItem === 'function' ? renderItem : function (d) {
        return d[renderItem];
      };
      return render(data, expanded, active, id);
    }
  }, {
    key: "renderIndicator",
    value: function renderIndicator() {
      var _this$props5 = this.props,
          data = _this$props5.data,
          expanded = _this$props5.expanded,
          expandIcons = _this$props5.expandIcons,
          loader = _this$props5.loader,
          childrenKey = _this$props5.childrenKey,
          fetching = _this$props5.fetching,
          iconClass = _this$props5.iconClass;
      var children = data[childrenKey];
      var icon = expandIcons ? expandIcons[expanded ? 1 : 0] :
      /*#__PURE__*/
      React.createElement("span", {
        className: treeClass('default-icon')
      });
      var indicator =
      /*#__PURE__*/
      React.createElement("a", {
        onClick: this.handleIndicatorClick,
        className: classnames(treeClass("icon-".concat(expanded ? 'sub' : 'plus')), iconClass)
      }, typeof icon === 'function' ? icon(data) : icon);
      if (children && children.length > 0) return indicator;
      if (Array.isArray(children) || children === null) return null;
      if (fetching && !children) return loading;
      if (loader && !fetching) return indicator;
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          data = _this$props6.data,
          onToggle = _this$props6.onToggle,
          onChange = _this$props6.onChange,
          expanded = _this$props6.expanded,
          onDragOver = _this$props6.onDragOver,
          other = _objectWithoutProperties(_this$props6, ["data", "onToggle", "onChange", "expanded", "onDragOver"]);

      return (
        /*#__PURE__*/
        React.createElement("div", {
          onDragOver: onDragOver
        }, this.renderIndicator(),
        /*#__PURE__*/
        React.createElement("div", {
          className: treeClass('content')
        }, onChange &&
        /*#__PURE__*/
        React.createElement(Checkbox, Object.assign({}, other, {
          onChange: onChange
        })),
        /*#__PURE__*/
        React.createElement("div", {
          className: treeClass('text'),
          onClick: this.handleNodeClick,
          onDoubleClick: this.handleNodeExpand
        }, this.renderNode())))
      );
    }
  }]);

  return Content;
}(PureComponent);

export default Content;